<div *ngIf="activeAuthModal === 'login'" class="fixed inset-0 z-[1100]">
  <app-login [isPopup]="true" (closed)="closeAuthModal()" (forgotPasswordRequested)="openAuthModal('forgot')"
    (signUpRequested)="openAuthModal('signup')"></app-login>
</div>

<div *ngIf="activeAuthModal === 'signup'" class="fixed inset-0 z-[1100]">
  <app-signup [isPopup]="true" (closed)="closeAuthModal()" (switchToLogin)="openAuthModal('login')"></app-signup>
</div>

<div *ngIf="activeAuthModal === 'forgot'"
  class="fixed inset-0 z-[1100] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
  (click)="closeAuthModal()">
  <div class="w-full max-w-[440px] relative" (click)="$event.stopPropagation()">
    <app-forgot-password [isPopup]="true" (closed)="closeAuthModal()"
      (backToLogin)="openAuthModal('login')"></app-forgot-password>
  </div>
</div>
<!-- Desktop Header (md and up) -->
<header
  class="hidden md:block fixed top-0 left-0 right-0 z-[9999] h-[58px] bg-[#0a0f1d]/95 backdrop-blur-md text-white border-b border-[rgba(231,181,63,0.15)] transition-all duration-300">
  <div class="mx-auto px-4 sm:px-6 h-full flex justify-between items-center gap-3">
    <a (click)="NavigateToHome()" class="flex items-center cursor-pointer h-full">
      <div class="w-[130px] h-full flex items-center justify-center">
        <img src="Logo/logo-opt.webp" alt="Casinoze Logo" class="max-h-[50px] w-auto object-contain" />
      </div>
    </a>

    <div class="flex items-center gap-4 sm:gap-6">
      <button (click)="toggleMusic()"
        class="text-[#94a3b8] hover:text-[#f5cf6b] transition duration-200 focus:outline-none flex items-center justify-center"
        aria-label="Toggle Music">
        <svg *ngIf="!isMusicMuted" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
        </svg>

        <svg *ngIf="isMusicMuted" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
        </svg>
      </button>

      <button (click)="RedirectToLogin()"
        class="bg-transparent border-none text-[#cbd5e1] text-[12px] font-bold uppercase tracking-[1.2px] hover:text-[#f5cf6b] transition duration-200 focus:outline-none whitespace-nowrap">
        Sign In
      </button>

      <button (click)="RedirectToRegister()"
        class="bg-[linear-gradient(#f5cf6b,#c8901a)] text-[#2e2206] font-black text-[12px] uppercase tracking-[1.2px] px-5 py-2.5 rounded-[12px] shadow-[0_10px_15px_-3px_rgba(231,181,63,0.2),0_4px_6px_-4px_rgba(231,181,63,0.2)] hover:brightness-110 transition duration-300 focus:outline-none whitespace-nowrap">
        Sign Up
      </button>
    </div>
  </div>
</header>

<!-- Mobile Header (below md) -->
<header
  class="md:hidden fixed top-0 left-0 right-0 z-[9999] h-[56px] bg-[#0a0f1d]/95 backdrop-blur-md text-white border-b border-[rgba(231,181,63,0.15)] transition-all duration-300">
  <div class="mx-auto px-4 h-full flex justify-between items-center">
    <!-- Left: hamburger -->
    <button (click)="toggleLandingSidebar()"
      class="flex-1 flex items-center justify-start text-white hover:text-[#f5cf6b] transition duration-200 focus:outline-none"
      aria-label="Menu">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>

    <!-- Center: logo -->
    <a (click)="NavigateToHome()" class="flex items-center justify-center cursor-pointer h-full">
      <img src="Logo/logo-opt.webp" alt="Casinoze Logo" class="max-h-[32px] w-auto object-contain" />
    </a>

    <!-- Right: JOIN -->
    <div class="flex-1 flex items-center justify-end">
      <button (click)="RedirectToRegister()"
        class="bg-gradient-to-br from-[#f5cf6b] to-[#c8901a] text-black font-bold text-[0.75rem] tracking-wider uppercase px-4 py-1.5 rounded-lg hover:from-[#facc15] hover:to-[#f5cf6b] transition duration-300 focus:outline-none whitespace-nowrap">
        Join
      </button>
    </div>
  </div>
</header>
<app-side-bar mode="landing" (createAccount)="openAuthModal('signup')" (signIn)="openAuthModal('login')"></app-side-bar>

<app-footer mode="landing" (authRequested)="openAuthModal($event)"></app-footer>

<div class="landing-main mt-16 px-4 mb-10">


  <div id="gameScrollSection">
    <app-casino-landing></app-casino-landing>
    <app-games-landing></app-games-landing>
  </div>
  <div id="contactScrollSection">
  </div>
</div>

<footer class="landing-footer-bar">
  <div class="footer-inner">
    <div class="w-[129px] h-[184px] flex-shrink-0 flex items-center justify-center">
      <img src="Logo/logo-opt.webp" alt="Casinoze Logo" class="brand__logo-img" />
    </div>

    <nav class="footer-nav">
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'dashboard'"
        (click)="scrollTo('games-section'); activeFooterSection = 'dashboard'">
        Dashboard
      </a>
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'wallet'"
        (click)="scrollTo('wallet-section'); activeFooterSection = 'wallet'">
        Wallet
      </a>
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'privacy'" (click)="GoToPrivacyPolicy()">
        Privacy
      </a>
      <a class="footer-nav-item" [class.active]="activeFooterSection === 'terms'" (click)="GoToTermsAndConditions()">
        Terms
      </a>
    </nav>

    <div class="footer-right">
      <span class="footer-copyright">
        <span class="copyright-dot"></span> © 2026 Casinoze.
      </span>
    </div>
  </div>
</footer>